import { ref } from 'vue'

export interface NotifyOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  variant?: 'primary' | 'danger' | 'amber'
  dismissible?: boolean
  onConfirm?: () => void
}

const visible = ref(false)
const current = ref<NotifyOptions>({
  title: '',
  message: '',
  confirmText: '确定',
  variant: 'primary',
  dismissible: true,
})

let confirmCallback: (() => void) | null = null

export const progress = ref(0)
export const showProgress = ref(false)
export const dismissible = ref(true)

export function showNotify(opts: NotifyOptions): void {
  current.value = {
    title: opts.title ?? '',
    message: opts.message,
    confirmText: opts.confirmText ?? '确定',
    variant: opts.variant ?? 'primary',
    dismissible: opts.dismissible ?? true,
  }
  dismissible.value = opts.dismissible ?? true
  confirmCallback = opts.onConfirm ?? null
  progress.value = 0
  showProgress.value = false
  visible.value = true
}

export function updateNotifyContent(title: string, message: string): void {
  current.value = { ...current.value, title, message }
  confirmCallback = null
}

export function updateProgress(percent: number): void {
  progress.value = percent
  showProgress.value = true
}

export async function handleNotifyConfirm(): Promise<void> {
  const cb = confirmCallback
  confirmCallback = null
  if (cb) {
    await cb()
  }
  if (!showProgress.value) {
    visible.value = false
  }
}

export function closeNotify(): void {
  if (!dismissible.value) return
  if (showProgress.value) return
  visible.value = false
  confirmCallback = null
}

export { visible, current }
